<template>
  <v-dialog persistent width="800px" height="600px" v-model="dialogSync">
    <v-form v-model="valid" ref="form">
      <v-card class="px-2 py-2">
        <v-card-title class="H4-Secondary-Center"
          >{{ isNew ? 'Add' : 'Edit' }} Recipient</v-card-title
        >
        <v-layout wrap class="ml-3">
          <v-flex xs5>
            <v-text-field label="E-mail" v-model="email" :rules="emailRules" />
          </v-flex>
          <v-flex xs12>
            <span class="H6-Secondary-Left">
              Units/Cost Centres
            </span>
            <div class="Body-1-Black-High-Emphasis-Left">
              Select which reports this user will receive
            </div>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Search Units"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-list>
              <v-list-tile v-for="unit of filteredUnits" :key="unit.id">
                <v-list-tile-action>
                  <v-checkbox v-model="unitsSelected" :value="unit.id"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title v-if="unit.meta && unit.meta.unit"
                    >Unit {{ unit.meta.unit }}</v-list-tile-title
                  >
                  <v-list-tile-title v-else>{{ unit.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="blue" @click="close">CANCEL</v-btn>
          <v-btn flat color="blue" @click="save" :disabled="!valid">save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import rules from '@/rules';

export default {
  props: {
    dialog: {
      default: false,
    },
    isNew: {
      default: true,
    },
    subscriber: {},
    site: Object,
  },

  data: () => ({
    unitsSelected: [],
    email: '',
    emailRules: [rules.required('required'), rules.email('Email not correctly formatted')],
    valid: true,
    search: '',
  }),

  watch: {
    subscriber() {
      this.email = this.subscriber.email;
      this.unitsSelected = this.subscriber.units.map((e) => e.id);
    },
  },

  computed: {
    dialogSync: {
      get() {
        return this.dialog;
      },
      set(v) {
        this.$emit('update:dialog', v);
      },
    },
    filteredUnits() {
      return this.site.locations.filter(
        (l) => l.meta && l.meta.unit && l.meta.unit.toString().indexOf(this.search) > -1,
      );
    },
  },

  methods: {
    close() {
      if (!this.isNew) {
        this.email = this.subscriber.email;
        this.unitsSelected = this.subscriber.units.map((e) => e.id);
      }
      this.dialogSync = false;
    },
    async save() {
      const update = {
        email: this.email,
        units: this.unitsSelected.map((e) => ({ id: e })),
      };
      this.subscriber.email = update.email;
      this.subscriber.units = update.units;
      if (this.isNew) {
        this.$emit('createSubscriber');
      }
      this.close();
    },
  },
};
</script>

<style></style>
